import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import {
  A11y,
  Autoplay,
  Navigation,
} from "swiper/modules";
import "swiper/css";

export default class extends Controller {
  static targets = ["nextBtn", "prevBtn"];

  connect() {
    this.swiper = new Swiper(this.element, {
      modules: [A11y, Autoplay, Navigation],
      ...this.defaultOptions,
    });
  }

  disconnect() {
    this.swiper.destroy();
    this.swiper = undefined;
  }

  get defaultOptions() {
    return {
      slideClass: 'reviews-slide',
      slideActiveClass: 'active',
      spaceBetween: 24,
      speed: 1000,
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
      loop: true,
      slidesPerView: "auto",
      centeredSlides: true,
      slideToClickedSlide: true,
      navigation: {
        nextEl: this.nextBtnTarget,
        prevEl: this.prevBtnTarget,
      },
    }
  }
}
